// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__oUJCN","containerFixed":"loader_containerFixed__1mMjL"};